import { render } from "./calc-item.vue?vue&type=template&id=9bd6a752&scoped=true"
import script from "./calc-item.vue?vue&type=script&lang=js"
export * from "./calc-item.vue?vue&type=script&lang=js"

import "./calc-item.vue?vue&type=style&index=0&id=9bd6a752&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd6a752"]])

export default __exports__